import { Button, Divider, FormControl, FormLabel, HStack, Input, InputGroup, InputRightElement, Stack, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { VscEye, VscEyeClosed } from 'react-icons/vsc';
import { changeUserPassword, getUser } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { ToastContainer } from 'react-toastify';
import { logoutSuccess } from '../../store/reducers';
import { registerFormTypes } from '../../types';
import { updatePasswordFormValidation } from '../../utils';
import { useFormik } from 'formik';

export const PasswordChange = () => {

    const [show, setShow] = React.useState(false);
    const handleClick = () => setShow(!show);

    const { user, is_updating_password } = useAppSelector(state => state.userReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const updatePasswordForm = useFormik({
        initialValues: {
            password: '',
            confirm_password: '',
        },
        validationSchema: updatePasswordFormValidation,
        validateOnBlur: true,
        onSubmit: (values: registerFormTypes) => {
            const newValues = {
                password: values.password,
            };
            dispatch(changeUserPassword(`${user._id}`, newValues)).then(() => {
                localStorage.clear();
                dispatch(logoutSuccess());
            });
            // alert(JSON.stringify(newValues, null, 2));
        }
    });

    useEffect(() => { }, [updatePasswordForm.values, is_updating_password]);

    useEffect(() => {
        dispatch(getUser());
    }, []);

    return (
        <Stack bg={'#FFFFFF'} p={6} borderRadius={6} >
            <Stack>
                <HStack justifyContent={'space-between'}>
                    <Text textTransform={'capitalize'} fontWeight={'semibold'} fontSize={'1.5rem'} >Change password</Text>
                </HStack>
                <Divider pt={2} />
            </Stack>
            <Stack pt={4} maxW={'xl'} alignSelf={'center'} w={['100%']}>
                <form onSubmit={updatePasswordForm.handleSubmit}>
                    <FormControl id="password" isRequired mb={updatePasswordForm.errors.password ? 5 : 4}>
                        <FormLabel>New password</FormLabel>
                        <InputGroup size='md'>
                            <Input
                                name='password'
                                pr='4.5rem'
                                type={show ? 'text' : 'password'}
                                placeholder='*********'
                                value={updatePasswordForm.values.password}
                                onChange={updatePasswordForm.handleChange}
                                onBlur={updatePasswordForm.handleBlur}
                            />
                            <InputRightElement width='4.5rem'>
                                <Button h='1.75rem' size='sm' onClick={handleClick}>
                                    {show ? <VscEyeClosed /> : <VscEye />}
                                </Button>
                            </InputRightElement>
                        </InputGroup>
                        {updatePasswordForm.errors.password && <Text fontSize='sm' color='red.400'>{updatePasswordForm.errors.password}</Text>}
                    </FormControl>
                    <FormControl id="confirm_password" isRequired mb={updatePasswordForm.errors.password ? 5 : 3}>
                        <FormLabel>Confirm new password</FormLabel>
                        <InputGroup size='md'>
                            <Input
                                name='confirm_password'
                                pr='4.5rem'
                                type={show ? 'text' : 'password'}
                                placeholder='**********'
                                value={updatePasswordForm.values.confirm_password}
                                onChange={updatePasswordForm.handleChange}
                                onBlur={updatePasswordForm.handleBlur}
                            />
                            <InputRightElement width='4.5rem'>
                                <Button h='1.75rem' size='sm' onClick={handleClick}>
                                    {show ? <VscEyeClosed /> : <VscEye />}
                                </Button>
                            </InputRightElement>
                        </InputGroup>
                        {updatePasswordForm.errors.confirm_password && <Text fontSize='sm' color='red.400'>{updatePasswordForm.errors.confirm_password}</Text>}
                    </FormControl>
                    <Stack spacing={10} pt={2}>
                        <Button
                            type='submit'
                            isLoading={is_updating_password}
                            disabled={is_updating_password}
                            loadingText="Submitting"
                            size="lg"
                            colorScheme={'yellow'}
                            _hover={{
                                bg: 'black',
                                color: 'white',
                            }}>
                            Submit
                        </Button>
                    </Stack>
                </form>
            </Stack>
            <ToastContainer />
        </Stack>
    );
};